/** SSR safe */
export const getDocument = (): Document | undefined => (typeof document !== 'undefined' ? document : undefined);

/** SSR safe */
export const getWindow = (): Window | undefined => (typeof window !== 'undefined' ? window : undefined);
